import React from 'react';
import Post from './Post';
import { getPosts } from './request';
import { useEffect, useState } from 'react';
import Page from './Page';
import {ColorRing} from 'react-loader-spinner';

const MainPage = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        (async () => { 
            setPosts(await getPosts());
        })();
    }, []);

    return <content>
            {posts?.length ? posts?.map((post) => <Post key={post} {...post} />) : 
            <ColorRing
              visible={true}
              width={"100%"}
              ariaLabel="blocks-loading"             
              wrapperClass="blocks-wrapper"
              colors={['#4d95b3', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
            />}
        </content>;
};

export default MainPage;
